import { Action } from 'redux';
import { SetPreviousUrl } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetPreviousUrlAction extends Action {
  previousUrl: string;
}

export function setPreviousUrl(previousUrl: string): SetPreviousUrlAction {
  return {
    type: SetPreviousUrl,
    previousUrl: previousUrl
  };
}

export const isSetPreviousUrlAction = isActionFactory<SetPreviousUrlAction>(SetPreviousUrl);
